import { make } from "vuex-pathify";
import { getAPI, postAPI } from "@/store/restAPI.js";//eslint-disable-line

// initial state
const state = {
    loading: false,
};

// getters
const getters = {};

// actions
const actions = {

    retrieveEvents({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("event/retrieveEvents").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveEventsBySearch({ commit }, filter) {
        commit("SET_LOADING", true);
        return getAPI("event/retrieveEventsBySearch" , filter)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      retrieveEventById({ commit }, id) {
        commit("SET_LOADING", true);
        return getAPI("event/retrieveEventById" , id)
          .then((response) => {
            return response;
          })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      saveEvent({ commit }, event) {
        commit("SET_LOADING", true);
        return postAPI("event/saveEvent", event).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      deleteEvent({ commit } , id) {
        commit("SET_LOADING", true);
        return postAPI("event/deleteEvent/" + id).then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

      countEvents({ commit }) {
        commit("SET_LOADING", true);
        return getAPI("event/count").then((res) => {
          return res;
        })
          .finally(function () {
            commit("SET_LOADING", false);
          });
      },

};

// mutations
const mutations = {
    ...make.mutations(state),
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };